import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { EnvironmentService } from "@lib/shared/data-access";
import { TenantModel } from "@lib/tenant/models";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class TenantService {
    private environmentService = inject(EnvironmentService);
    private httpClient = inject(HttpClient);

    public isTenantSelectionSidebarVisibleSignal = signal(false);

    public showTenantSelectionSidebar(): void {
        this.isTenantSelectionSidebarVisibleSignal.set(true);
    }

    public getTenant(id: number): Observable<TenantModel> {
        return this.httpClient.get<TenantModel>(`${this.environmentService.authApiUrl}/api/v1/tenants/${id}`);
    }

    public getAccessibleTenants(): Observable<TenantModel[]> {
        return this.httpClient.get<TenantModel[]>(`${this.environmentService.authApiUrl}/api/v1/tenants`);
    }
}